import * as types from '../../actions/types';
import i18n from '../../i18n';

export default (state = { isLoaded: false, isLoading: false, shards: [] }, action) => {
	switch(action.type) {
		case types.SHARDS_LOADING:
			return { ...state, isLoading: true };
		case types.RECEIVE_SHARDS:
			let shards = action.shards;

			shards.forEach(shard => shard.countries.sort((a, b) => {
				a = i18n.t(`countries.${a}`);
				b = i18n.t(`countries.${b}`);

				if(String.prototype.localeCompare) {
					return a.localeCompare(b, i18n.currentLanguage());
				} else {
					return a > b ? 1 : -1;
				}
			}));

			shards.sort((a, b) => {
				a = i18n.t(`shards.${a.shard}`);
				b = i18n.t(`shards.${b.shard}`);

				if(String.prototype.localeCompare) {
					return a.localeCompare(b, i18n.currentLanguage());
				} else {
					return a > b ? 1 : -1
				}
			});

			return { ...state, isLoaded: true, isLoading: false, shards };
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/store/reducers/shards.js